import React, { Component, createRef } from 'react'
import _ from 'lodash'
import {
  Form,
  Icon,
  Input,
  InputNumber,
  Button,
  Popconfirm,
  Spin,
  Modal,
  message,
  Select,
  Tooltip,
  Row as AntRow,
  Col as AntCol
} from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { withTranslation } from 'react-i18next'
import { FaDesktop, FaDownload, FaExclamationTriangle } from 'react-icons/fa'
import CreatableSelect from 'react-select/creatable'
import {
  SortableContainer,
  SortableElement,
  sortableHandle,
  arrayMove
} from 'react-sortable-hoc'

import api from '../../../../../services/api'
import { general, config } from '../../../../../constants'
import { getToken, fetchRefreshToken } from '../../../../../services/api/user'
import './CourseCreateMain.scss'
import Badge from './components/Badge'
import Certificate from './components/Certificate'
import ContentLoader from '../../internal/ContentLoader'
import { Row, Col } from '../../../../../styles'
import { Lessons } from '../../../../../styles/blocks'
import {
  FormHeader,
  MarketPlaceTopSection,
  MarketPlaceMidSection,
  MarketPlaceBottomSection
} from './components'
import ShowContactsModal from '../../../../Events/Create/components/internal/ShowContactsModal'
import { FileUpload } from '../../../../../components'
import AiCourseCreation from '../../../../../components/AiCourseCreation/index.'
import { TourContext } from '../../../../../components/Tour'
import { createCourseTourConfig } from '../../../../../components/Tour/configs/createCourseTourConfig'

import history from '../../../../../history'
import ImageSelect from '../../../../../components/Form/ImageSelect/ImageSelect'
import AiTemplateSelection from '../../../../../components/AiCourseCreation/AiTemplateSelection/AiTemplateSelection'
import langOptions from '../../../../../components/CloningModal/langOptions'

const { Option } = Select
const { confirm } = Modal

class CourseCreateMain extends Component {
  search = window.location.search
  params = new URLSearchParams(this.search)
  isMarketPlaceQuery = this.params.get('mpquery')

  DragHandle = sortableHandle(() => <div className="b-page__drag" />)

  Page = SortableElement(({ children }) => {
    return <li className="b-pages__item">{children}</li>
  })

  Pages = SortableContainer(({ children }) => {
    return <ul className="b-pages">{children}</ul>
  })
  constructor(props) {
    super(props)
    this.lastFetchId = 0
    this.state = {
      refreshToken: null,
      shlToken: null,
      isCover: false,
      aiVisible: false,
      isMarketPlace: false,
      isCoverLoading: props.courseId && true,
      isFinishing: false,
      isSaving: false,
      options: [],
      value: [],
      group: null,
      inputValue: '',
      isTopicLoading: false,
      image: null, // your-image-url or as base64
      file: null,
      isTopicsMax: false,
      newImageUrl: null,
      showTextModal: false,
      selectedContent: '',
      content: '',
      contentHTML: '',
      textPosition: {
        height: 200,
        width: 250,
        x: 23,
        y: 100
      },
      applyChanges: false,
      isImageLoading: false,
      isCertificateLoading: false,
      isBadgeLoading: false,
      openBadgeModal: false,
      openCertificateModal: false,
      fetching: false,
      emails: [],
      emailList: [],
      categories: [],
      showContactModal: false,
      isCreator: true,
      isCreatingCourseByHuman: true,
      showAiCourseCreationModal: false,
      isFetchingAiContent: false,
      aiContent: null,
      openTemplateModal: false,
      isGeneratingCourse: false,
    }
    this.loadOptions = _.debounce(this.loadOptions, 500)
    this.imageRef = createRef()
  }

  async componentDidMount() {
    const {
      courseBuilderActions: { getLessonsList },
      courseBuilder: { courseId },
      match: {
        params: { id }
      },
      course: { item }
    } = this.props

    try {
      const token = await getToken()
      const refreshToken = await fetchRefreshToken()
      this.setState({ shlToken: token, refreshToken: refreshToken })
    } catch (err) {
      console.error('Error fetching SHL token:', err)
    }

    this.setState({
      isMarketPlace: this.isMarketPlaceQuery == 'true' ? true : false
    })
    this.fetchUserEmails()
    this.fetchCategories()
    if (id || courseId) {
      getLessonsList(id || courseId)

      if (!_.isEmpty(item)) {
        this.handleOldTopics()
      }
    }
  }

  handleOldTopics = () => {
    const {
      course: { item }
    } = this.props

    if (!item) return
    const { topics, creator_id } = item

    this.getOldTopics(topics)

    if (creator_id !== this.props.user.info.id) {
      this.setState({
        isCreator: false
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props) {
      const { showTextModal, contentHTML } = this.state
      const div = document.getElementById('showtext')
      if (!showTextModal && contentHTML && div) {
        div.innerHTML = contentHTML
        return div
      }

      const {
        isCourseReducerUpdated,
        courseBuilder: { courseId },
        course: { item },
        match: {
          params: { id }
        }
      } = this.props
      if (
        JSON.stringify(
          prevProps.course.item && prevProps.course.item.topics
        ) !== JSON.stringify(item.topics)
      ) {
        this.handleOldTopics()
      }

      if (
        isCourseReducerUpdated &&
        isCourseReducerUpdated !== prevProps.isCourseReducerUpdated
      ) {
        this.showErrorMessageForMarketPlace()
      }

      if (!id && courseId) {
        window.history.replaceState(null, null, `/courses/${courseId}/edit`)
      }
    }

    // Check if badge modal just opened
    if (
      prevState.openBadgeModal !== this.state.openBadgeModal &&
      this.state.openBadgeModal
    ) {
      // Modal just opened, scroll modal content to top
      setTimeout(() => {
        const modalBody = document.querySelector('.ant-modal-body')
        if (modalBody) {
          modalBody.scrollTop = 0
        }

        const badgeModalWrap = document.querySelector(
          '.badge-creator-modal-wrap'
        )
        if (badgeModalWrap) {
          badgeModalWrap.scrollTop = 0
        }
      }, 150)
    }
  }

  handleValue = async (field, value) => {
    const { courseBuilderActions } = this.props
    await courseBuilderActions.handleCourseInput(field, value)
    this.handleSubmit()
  }

  handleTitle = _.debounce(v => this.handleValue('courseTitle', v), 1000)
  handleCategory = _.debounce(v => this.handleValue('courseCategory', v), 1000)
  handleSwitch = _.debounce(v => this.handleValue('courseIsFree', v), 1000)
  handlePrice = _.debounce(v => this.handleValue('coursePrice', v), 1000)
  handleVideoLink = _.debounce(
    v => this.handleValue('courseVideoLink', v),
    1000
  )
  handleNumberOfLessons = _.debounce(
    v => this.handleValue('courseNoOfLessons', v),
    1000
  )

  handleNumberOfVideos = _.debounce(v => {
    if (v >= 0) {
      this.handleValue('courseNoOfVideos', v)
    } else {
      console.log('show error')
    }
  }, 1000)

  // handleOrganization = _.debounce(
  //   v => this.handleValue('courseOrganization', v),
  //   1000
  // )
  // handleGroup = _.debounce(v => this.handleValue('courseGroup', v), 1000)

  handleOrganiser = _.debounce(
    v => this.handleValue('courseOrganiser', v),
    1000
  )
  handleTopics = _.debounce(v => this.handleValue('courseTags', v), 1000)
  handleDescription = _.debounce(
    v => this.handleValue('courseDescription', v),
    1000
  )
  handleMarketPlaceDescription = _.debounce(
    v => this.handleValue('courseMarketPlaceDescription', v),
    1000
  )
  handleObjectives = _.debounce(
    v => this.handleValue('courseObjectives', v),
    1000
  )
  handleOutline = _.debounce(v => this.handleValue('courseOutline', v), 1000)
  handlePassScore = _.debounce(
    v => this.handleValue('coursePassScore', v),
    1000
  )

  handleShareProfile = _.debounce(
    v => this.handleValue('courseShareProfile', v),
    1000
  )

  handlePriceToEdit = _.debounce(
    v => this.handleValue('coursePriceToEdit', v),
    1000
  )

  handleEditPermission = _.debounce(
    v => this.handleValue('courseEditPermission', v),
    1000
  )

  handleGroupSelect = val => {
    this.handleGroup(val)
    this.setState({ group: val })
  }

  onDrop = (file, handleAfterUpload, handlebeforeUpload) => {
    const image = URL.createObjectURL(file)
    this.handleAfterUpload = handleAfterUpload
    this.handlebeforeUpload = handlebeforeUpload
    this.setState({
      file,
      image
    })
  }

  badgePresentationUpload = (body, imageType) => {
    const { t, upload } = this.props
    this.toggleLoadingState(imageType)
    this.setState({ openBadgeModal: false, openCertificateModal: false })
    upload(body)
      .then(res => {
        const { id } = res
        this.toggleLoadingState(imageType)
        this.handleRewardImageUpload(imageType, id)
      })
      .catch(() => {
        this.toggleLoadingState(imageType)
        message.error(t('v4:error_occured_try_again'))
      })
  }

  handleRewardImageUpload = (type, id) => {
    const { courseBuilderActions } = this.props
    if (type === 'Certificate') {
      courseBuilderActions.handleCourseInput('courseCertId', id)
    } else {
      courseBuilderActions.handleCourseInput('courseBadgeId', id)
    }
    this.handleSubmit()
  }

  toggleLoadingState = type => {
    if (type === 'Certificate') {
      this.setState(state => ({
        isCertificateLoading: !state.isCertificateLoading
      }))
    } else {
      this.setState(state => ({ isBadgeLoading: !state.isBadgeLoading }))
    }
  }

  deleteLesson = (e, lessonId) => {
    e.stopPropagation()

    const {
      courseBuilderActions: { deleteLessonFromCourse },
      courseBuilder: { courseId }
    } = this.props

    deleteLessonFromCourse(courseId, lessonId)
  }

  handleSubmit = async e => {
    e && e.preventDefault()

    const { value, group } = this.state

    const {
      form,
      courseBuilderActions: { updateCourse, createCourse },
      course: { item: course },
      courseBuilder: {
        courseImg,
        courseId,
        isCreation,
        coursePassScore,
        courseCertId,
        courseBadgeId,
        courseEmails,
        courseCategories,
        courseAttachments,
        courseLang,
        courseEditPermission
      },
      user: {
        info: { username, bio, linkedin }
      }
    } = this.props

    try {
      const values = await new Promise((resolve, reject) => {
        form.validateFields((err, fields) => {
          if (err) reject(err)
          else resolve(fields)
        })
      })

      if (!courseImg.id) {
        this.setState({ isCover: true })
        return
      }

      if (isCreation) {
        return
      }

      if (coursePassScore && (coursePassScore < 1 || coursePassScore > 99)) {
        return
      }

      const courseData = {
        ...values,
        cover_id: courseImg.id,
        cert_id: courseCertId,
        badge_id: courseBadgeId,
        host_emails: courseEmails,
        categories: courseCategories,
        attachments: courseAttachments,
        lang: courseLang
      }
      courseData.topics = _.map(value, 'id')
      courseData.group_id = group
      if (!courseData.title || !courseData.cover_id) return

      // Seting saving loading state
      this.setState({ isSaving: true })

      if (courseId) {
        const { priceToEdit, price, ...rest } = courseData

        // Price validation
        if (priceToEdit > price) return

        const newCourseData = {
          ...rest,
          marketplace: {
            ...rest.marketplace,
            trainer: username,
            bio,
            linkedin
          }
        }

        const debouncedUpdate = _.debounce(async () => {
          await updateCourse(newCourseData, courseId)
          setTimeout(() => {
            this.setState({ isSaving: false })
          }, 300)
        }, 500)

        debouncedUpdate()
      } else {
        await createCourse(courseData)
        this.setState({ isSaving: false })
      }
    } catch (err) {
      console.error('test Validation failed:', err)
    }
  }

  showErrorMessageForMarketPlace = () => {
    const {
      courseBuilder: {
        courseId,
        courseTitle,
        courseImg,
        courseOrganiser,
        // courseCategory,
        courseIsFree,
        courseMarketPlaceDescription,
        courseNoOfLessons,
        courseNoOfVideos,
        courseObjectives,
        // courseOrganization,
        courseOutline,
        coursePrice,
        // courseGroup,
        courseVideoLink
      },
      course: { item: course },
      t,
      user: {
        info: { isAdmin }
      }
    } = this.props

    if (!isAdmin || !courseId || course.is_restricted) return

    let data = {
      courseId,
      courseTitle,
      courseImgId: courseImg.id,
      courseOrganiser,
      // courseCategory,
      courseIsFree,
      courseMarketPlaceDescription,
      courseNoOfLessons,
      courseNoOfVideos,
      courseObjectives,
      courseOutline,
      ...(!courseIsFree && { coursePrice }),
      courseVideoLink
    }

    let errorData = Object.keys(data).filter(k => {
      if (data[k] === '' || data[k] === undefined || data[k] === null) {
        return true
      } else {
        return false
      }
    })
    if (errorData.length) {
      message.warning(t('v4:not_complete'))
      return true
    } else {
      message.success(t('v4:complete'))
      return false
    }
  }

  finish = isPublish => {
    const { value } = this.state

    const {
      form,
      course: { item: course },
      courseBuilder: {
        courseLang,
        courseImg,
        courseId,
        isCreation,
        courseCertId,
        courseBadgeId,
        courseEmails,
        courseCategories,
        lessons: { list }
      },
      history,
      rootPath
    } = this.props

    const allLessonsHaveCoverId = list.every(lesson => lesson.cover_id)

    if (!allLessonsHaveCoverId) {
      Modal.error({
        title: 'Error ! Please add a cover image for all the lessons.',
        content:
          'Click on the lesson title to visit the lesson and add a cover image.',
        centered: true,
        style: { minWidth: '500px' }
      })

      return
    }

    form.validateFields((err, values) => {
      if (isCreation) {
        return
      }

      const courseData = {
        ...values,
        cover_id: courseImg.id,
        cert_id: courseCertId,
        badge_id: courseBadgeId,
        is_finished: true,
        host_emails: courseEmails,
        categories: courseCategories,
        lang: courseLang
      }
      courseData.topics = _.map(value, 'id')
      this.setState({ isFinishing: true })
      return api.courses.courseUpdate(courseData, courseId).then(() => {
        this.setState({ isFinishing: false })
        if (isPublish) {
          history.push(`${rootPath}/publish`)
        } else {
          history.push('/workshop')
        }
      })
    })
  }

  showLessonById = id => {
    const { fetchLessonById, history, rootPath } = this.props

    fetchLessonById(id)
    history.push(`${rootPath}/lesson-create/${id}`)
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    const {
      courseBuilder: { lessons, courseId },
      reorderLessons
    } = this.props
    const newLessons = arrayMove(lessons.list, oldIndex, newIndex)
    const newOrderIds = newLessons.map(el => el.id)

    if (reorderLessons) {
      reorderLessons(newLessons)
    }

    api.courses.updateLessonsOrderByCourseId(courseId, newOrderIds)
  }

  getOldTopics = topics => {
    const {
      topics: { list: topicList, isFetching }
    } = this.props
    if (!isFetching) {
      const topic =
        topics &&
        topics.map(item => _.head(topicList.filter(topic => topic.id === item)))
      const newValue =
        topic && topic.map(item => item && this.createOption(item))
      this.setState({
        value: newValue
      })
    }
  }

  handleChange = (newValue, actionMeta) => {
    if (actionMeta.removedValue) {
      this.setState(
        {
          value: newValue,
          inputValue: '',
          isTopicLoading: false,
          isTopicsMax: false
        },
        () => {
          // this.handleSubmit()
          this.handleValue('courseTags', _.map(newValue, 'id'))
        }
      )
    } else if (!_.isEmpty(newValue) && newValue.length > 5) {
      this.setState({
        isTopicsMax: true
      })
    } else {
      this.setState(
        {
          value: newValue,
          inputValue: '',
          isTopicLoading: false,
          isTopicsMax: false
        },
        () => {
          // this.handleSubmit()
          this.handleValue('courseTags', _.map(newValue, 'id'))
        }
      )
    }
    this.isModalSelectOpen()
  }
  handleCreate = inputValue => {
    this.setState({ isTopicLoading: true })
    const { options, value } = this.state
    const topic = { title: inputValue }
    if (!_.isEmpty(value) && value.length >= 5) {
      this.setState({
        isTopicsMax: true,
        isTopicLoading: false
      })
    } else {
      api.topics.createTopics(topic).then(({ data }) => {
        if (!_.isEmpty(data[0])) {
          const newOption = this.createOption(data[0])
          this.props.updateTopicList(data[0])

          this.setState(
            {
              isTopicLoading: false,
              options: [...options, newOption],
              isTopicsMax: false,
              value: [...value, newOption],
              inputValue: ''
            },
            () => {
              this.handleSubmit()
              this.handleValue('courseTags', _.map([...value, newOption], 'id'))
            }
          )
        }
      })
    }
    this.isModalSelectOpen()
  }

  createOption = topic => {
    const option = {
      label: topic.title,
      value: topic.title,
      id: topic.id
    }
    return option
  }

  createOptionList = list => {
    const options = list.map(topic => this.createOption(topic))
    this.setState({
      options,
      isTopicLoading: false
    })
  }

  loadOptions = inputValue => {
    if (inputValue.length > 0 && inputValue.length <= 50) {
      this.setState({
        isTopicLoading: true
      })
      const params = {
        search: inputValue.trim(),
        limit: 10,
        offset: 0
      }
      api.topics.getTopics(params).then(({ data }) => {
        this.setState({
          inputValue
        })
        this.createOptionList(data)
      })
    }
  }

  LoadingIndicator = () => (
    <Icon style={{ paddingRight: '10px' }} type="loading" />
  )

  handleOpenModel = () => {
    const {
      courseBuilder: { courseId, courseLang },
      t
    } = this.props
    if (this.context && this.context.endTour) {
      this.context.endTour()
    }
    history.push(`/course/${courseId}/course-ai`, { courseLang })
  }
  handleImageSuccess = res => {
    const { id, title, filename } = res

    if (id) {
      this.setState(
        {
          isCover: false,
          isCoverLoading: false,
          file: null,
          image: null,
          newImageUrl: null,
          showTextModal: false,
          selectedContent: '',
          content: '',
          contentHTML: '',
          textPosition: {
            height: 200,
            width: 250,
            x: 23,
            y: 100
          },
          applyChanges: false,
          isImageLoading: false,
          currentImageFileName: title || filename
        },
        () => {
          this.handleAfterUpload && this.handleAfterUpload()
        }
      )
    }
    this.handleSubmit()
  }

  handleClosePopup = type => {
    if (type === general.SAVE) {
      this.setState({
        image: null
      })
    } else {
      this.setState({
        image: null,
        file: null
      })
      this.handleAfterUpload && this.handleAfterUpload()
    }
  }

  isModalSelectOpen = () => {
    const { inputValue, value, isTopicsMax } = this.state
    return !_.isEmpty(value) && value.length >= 3 && isTopicsMax
      ? false
      : inputValue.length > 0
  }

  hideModal = () => {
    this.setState({
      modalOpen: false
    })
  }

  handleInsertData = (privateMedia, publicMedia, orgMedia) => {
    let tempData = []
    if (privateMedia) {
      const { rows: privateData } = privateMedia
      privateData.forEach(data => {
        tempData.push(data)
      })
    }

    if (publicMedia) {
      const { rows: publicData } = publicMedia
      publicData.forEach(publicData => {
        tempData.push(publicData)
      })
    }

    if (orgMedia) {
      const { rows: orgData } = orgMedia
      orgData.forEach(orgData => {
        tempData.push(orgData)
      })
    }

    const selectedItem = _.head(tempData.filter(value => value.isSelected))

    this.setState({
      selectedItem
    })
  }

  hidePreviewModal = () => {
    this.setState({
      selectedItem: null
    })
  }

  handleShowTextModal = () => {
    this.setState({ showTextModal: !this.state.showTextModal })
  }

  onToggleMarketPlace = () => {
    this.setState({ isMarketPlace: !this.state.isMarketPlace }, () => {
      this.showErrorMessageForMarketPlace()
    })
  }

  toggleBadgeModal = () => {
    this.setState(
      state => ({ openBadgeModal: !state.openBadgeModal }),
      () => {
        // If modal is opening, scroll modal content to top
        if (this.state.openBadgeModal) {
          // Use setTimeout to ensure modal is rendered
          setTimeout(() => {
            // Find and scroll modal content to top
            const modalBody = document.querySelector('.ant-modal-body')
            if (modalBody) {
              modalBody.scrollTop = 0
            }

            // Find and scroll badge modal wrapper to top
            const badgeModalWrap = document.querySelector(
              '.badge-creator-modal-wrap'
            )
            if (badgeModalWrap) {
              badgeModalWrap.scrollTop = 0
            }
          }, 100)
        }
      }
    )
  }
  toggleTemplateModal = () => {
    this.setState(state => ({ openTemplateModal: !state.openTemplateModal }))
  }

  toggleCertificateModal = () => {
    this.setState(state => ({
      openCertificateModal: !state.openCertificateModal
    }))
  }

  toggleContactModal = async () => {
    this.setState(prevState => ({
      showContactModal: !prevState.showContactModal
    }))
  }

  fetchUserEmails = () => {
    const {
      user: {
        info: { active_organization_id }
      }
    } = this.props
    this.setState({ allUsers: [], fetching: true }, () => {
      api.organizations
        .getUsersByOrganizationId(active_organization_id)
        .then(({ data }) => {
          if (data && !data.errorMessage) {
            const userData = data.filter(item => item.user !== null)
            this.setState({
              allUsers: userData,
              emailList: userData,
              fetching: false
            })
          }
        })
    })
  }
  fetchCategories = async () => {
    const { getCategories } = this.props
    await getCategories()
  }

  simplifyUserList = arr =>
    arr.map(item => ({
      text: item.user.email,
      value: item.user.email,
      id: item.user.id
    }))
  handleUserSearch = value => {
    const { allUsers } = this.state
    const results = allUsers.filter(item =>
      item.user.email.toLowerCase().includes(value.toLowerCase())
    )
    this.setState({
      emailList: value ? results : allUsers
    })
  }

  handleChangeLang = e => {
    this.handleValue('courseLang', e)
  }

  handleEmailChange = selectedValue => {
    // if (selectedValue.length > 5)
    //   return
    this.setState(
      prevState => {
        if (prevState.showContactModal) {
          return {
            emails: selectedValue,
            showContactModal: false
          }
        }
        return {
          emails: selectedValue
        }
      },
      () => {
        const {
          form: { setFieldsValue }
        } = this.props
        setFieldsValue({ host_emails: this.state.emails })
        this.handleValue('courseEmails', selectedValue)
        // this.props.App.handleAttendeeEmailChange(this.state.emails)
      }
    )
  }
  handleCategoryChange = _.debounce(selectedValue => {
    this.setState(
      prevState => {
        if (prevState.showContactModal) {
          return {
            categories: selectedValue,
            showContactModal: false
          }
        }
        return {
          categories: selectedValue
        }
      },
      () => {
        const {
          form: { setFieldsValue }
        } = this.props
        setFieldsValue({ categories: this.state.categories })
        this.handleValue('courseCategories', selectedValue)
      }
    )
  }, 1000)

  onFiles = filesArray => {
    const {
      courseBuilder: { courseAttachments = [] },
      courseBuilderActions
    } = this.props
    if (_.isEmpty(filesArray) && _.isEmpty(courseAttachments)) return
    const filesById = filesArray.map(item => item.id)
    courseBuilderActions.handleCourseInput(
      'courseAttachmentDetails',
      filesArray
    )
    filesById && this.handleValue('courseAttachments', filesById)
  }

  onToggleCreatingCourseByHuman = val => {
    const { t } = this.props
    this.setState({
      isCreatingCourseByHuman: val
    }, () => {
      if (this.context && this.context.isTourActive && this.context.currentTourId === 'create-course') {
        const newConfig = createCourseTourConfig(t, val)
        if (this.context.updateTourSteps) {
          this.context.updateTourSteps(newConfig.steps)
        }
      }
    })
  }
  handleTableOfContentModalClose = hasContentGenerationStarted => {
    const { t } = this.props
    if (hasContentGenerationStarted) {
      this.setState({ showAiCourseCreationModal: false })
      return
    }
    confirm({
      title: t('v4:are_you_sure_want_close'),
      content: t('v4:all_your_changes_will_be_lost'),
      onOk: () => {
        this.setState({ showAiCourseCreationModal: false })
      },
      okText: t('v4:ok'),
      cancelText: t('v4:cancel')
    })
  }
  confirmSetCourseTemplate = templateData => {
    const {
      courseBuilder: { courseId },
      courseBuilderActions,
      t
    } = this.props

    let data = {
      background_color: templateData.background_color,
      template_id: templateData.template_id,
      background_id: templateData.background_id,
      opacity: templateData.opacity,
      logo_id: templateData.logo_id
    }
    this.setState({ isGeneratingCourse: true })
    confirm({
      width: '500px',
      title: t('v5:are_you_sure_you_want_to_update_your_course_template'),
      content: (
        <div className="ai-warning">
          <p>{t('v5:this_will_automatically_update_the_template')}</p>
          <p>
            {t('v5:note_this_process_will_change_the_course_lesson_layouts')}
          </p>
        </div>
      ),
      onCancel: () => {
        this.setState({ isGeneratingCourse: false })
      },
      onOk: () => {
        api.courses
          .updateAllAILessons({ courseId }, data)
          .then(async () => {
            data.logo_img = templateData.logo_img
            data.background_img = templateData.background_img
            await courseBuilderActions.handleCourseInput('templateData', data)
            this.setState({
              openTemplateModal: false,
              isGeneratingCourse: false
            })
            message.success('Course template updated successfully.')
          })
          .catch(err => {
            this.setState({ isGeneratingCourse: false })
            message.error(err.message)
          })
      },
      okText: t('v4:ok'),
      cancelText: t('v4:cancel')
    })
  }

  handleOpenSelectLibraryModal = e => {
    if (e) {
      e.stopPropagation()
    }
    this.setState({
      modalOpen: true
    })
  }

  handleOpenCanva = e => {
    if (e) {
      e.stopPropagation()
    }
    this.useCanva('Presentation')
  }

  onCoverChange = async coverObj => {
    const { courseBuilderActions } = this.props

    await courseBuilderActions.handleCourseInput('courseImg', coverObj)

    this.handleImageSuccess(coverObj)
  }

  handleScreenRecording = async (isSimulation = false) => {
    const { shlToken, refreshToken } = this.state
    const {
      courseBuilder: { courseId }
    } = this.props

    const userId =
      this.props &&
      this.props.user &&
      this.props.user.info &&
      this.props.user.info.id

    if (!userId) {
      console.error('User ID is missing. Cannot proceed with deep link.')
      message.error('User ID is missing. Please try again.')
      return
    }

    console.log('User token: ', userId)

    const base_Url = config.baseURL.replace(/\/v1\/?$/, '')
    const ai_Url = config.questionAnswerAiUrl

    console.log(
      'shlToken:',
      shlToken,
      '| base_Url:',
      base_Url,
      '| ai_Url:',
      ai_Url,
      '| userId:',
      userId,
      '| courseId:',
      courseId
    )

    console.log('refreshToken', refreshToken)

    // Build deep link based on button clicked
    let deepLink = `sharelookapp://open?token=${shlToken}&refreshToken=${refreshToken}&base_Url=${base_Url}&ai_Url=${ai_Url}&userId=${userId}&course_Id=${courseId}&template_id=7`

    if (isSimulation) {
      deepLink += '&IsUnityLesson=true'
    }

    console.log('deepLink', deepLink)

    // Show confirmation modal first (provides user gesture)
    this.showLaunchConfirmation(deepLink)
  }

  // Show confirmation modal using Ant Design
  showLaunchConfirmation = deepLink => {
    const { t } = this.props
    const modal = Modal.confirm({
      title: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <FaDesktop style={{ marginRight: '8px', color: '#1890ff' }} />
          {t('v4:launch_sharelook_application')}
        </div>
      ),
      content: (
        <div>
          <p style={{ marginBottom: '16px' }}>
            {t('v4:this_will_open_for_screen_recording')}
          </p>
          <p style={{ color: '#666', fontSize: '14px', marginBottom: '0' }}>
            {t('v4:sharelook_dosenot_open')}
          </p>
        </div>
      ),
      okText: (
        <span>
          <FaDesktop style={{ marginRight: '6px' }} />
          {t('v4:open_sharelook')}{' '}
        </span>
      ),
      cancelText: t('v4:cancel'),
      okType: 'primary',
      width: 450,
      onOk: () => {
        this.attemptAppLaunch(deepLink)
      },
      onCancel: () => {
        if (this.context && this.context.endTour) {
          this.context.endTour()
        }
        console.log('User cancelled app launch')
      },
      footer: (_, { OkBtn, CancelBtn }) => (
        <div style={{ textAlign: 'center' }}>
          <CancelBtn />
          <OkBtn />
          <Button
            type="default"
            onClick={() => {
              window.open(
                'https://mj-scorm-bucket.s3.us-east-1.amazonaws.com/windows-screen-capture-app/ELearningSetup.exe',
                '_blank'
              )
              modal.destroy()
            }}
            style={{ marginLeft: '8px' }}
          >
            <FaDownload style={{ marginRight: '6px' }} />
            {t('v4:download_app')}
          </Button>
        </div>
      )
    })
  }

  // Alternative using Modal.info for better control
  showLaunchConfirmationModal = deepLink => {
    const { t } = this.prrops
    Modal.info({
      title: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '16px'
          }}
        >
          <FaDesktop
            style={{ marginRight: '8px', color: '#1890ff', fontSize: '20px' }}
          />
          {t('v4:launch_sharelook_application')}
        </div>
      ),
      content: (
        <div>
          <p style={{ marginBottom: '16px', lineHeight: '1.5' }}>
            {t('v4:this_will_open_for_screen_recording')}
          </p>
          <p style={{ color: '#666', fontSize: '14px', marginBottom: '20px' }}>
            {t('v4:sharelook_dosenot_open')}
          </p>
          <div style={{ textAlign: 'center' }}>
            <Button
              type="primary"
              size="large"
              onClick={() => {
                Modal.destroyAll()
                this.attemptAppLaunch(deepLink)
              }}
              style={{ marginRight: '12px' }}
            >
              <FaDesktop style={{ marginRight: '6px' }} />
              {t('v4:open_sharelook')}
            </Button>
            <Button
              type="default"
              size="large"
              onClick={() => {
                window.open(
                  'https://mj-scorm-bucket.s3.us-east-1.amazonaws.com/windows-screen-capture-app/ELearningSetup.exe',
                  '_blank'
                )
                Modal.destroyAll()
              }}
            >
              <FaDownload style={{ marginRight: '6px' }} />
              {t('v4:download_app')}
            </Button>
          </div>
        </div>
      ),
      okText: 'Close',
      width: 450,
      centered: true
    })
  }

  // Attempt to launch the app with proper user gesture
  attemptAppLaunch = deepLink => {
    console.log('Attempting to launch ShareLook with deepLink:', deepLink)

    // Show loading message
    const hide = message.loading('Opening ShareLook...', 2)

    // Track if app launched successfully
    let appLaunched = false

    const detectAppLaunch = () => {
      const onBlur = () => {
        appLaunched = true
        cleanup()
        hide()
        message.success('ShareLook opened successfully!')
      }

      const onVisibilityChange = () => {
        if (document.hidden) {
          appLaunched = true
          cleanup()
          hide()
          message.success('ShareLook opened successfully!')
        }
      }

      const cleanup = () => {
        window.removeEventListener('blur', onBlur)
        document.removeEventListener('visibilitychange', onVisibilityChange)
      }

      // Listen for app launch indicators
      window.addEventListener('blur', onBlur)
      document.addEventListener('visibilitychange', onVisibilityChange)

      // Check after delay if app didn't launch
      setTimeout(() => {
        cleanup()
        hide()
        if (!appLaunched) {
          this.showAppNotFound()
        }
      }, 3000)
    }

    try {
      // Method 1: Direct window location (most reliable with user gesture)
      detectAppLaunch()
      window.location.href = deepLink
    } catch (error) {
      console.error('Direct launch failed, trying fallback:', error)

      try {
        // Method 2: Create and click link (fallback)
        const link = document.createElement('a')
        link.href = deepLink
        link.target = '_self'
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } catch (fallbackError) {
        console.error('All launch methods failed:', fallbackError)
        hide()
        this.showAppNotFound()
      }
    }
  }

  // Show message when app launch fails
  showAppNotFound = () => {
    const { t } = this.prrops
    Modal.error({
      title: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <FaExclamationTriangle
            style={{ marginRight: '8px', color: '#ff4d4f' }}
          />
          {t('v4:sharelook_not_found')}
        </div>
      ),
      content: (
        <div>
          <p style={{ marginBottom: '16px', lineHeight: '1.5' }}>
            {t('v4:sharelook_screen_capture_application_not_be_opened')}
          </p>
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <Button
              type="primary"
              size="large"
              onClick={() => {
                window.open(
                  'https://mj-scorm-bucket.s3.us-east-1.amazonaws.com/windows-screen-capture-app/ELearningSetup.exe',
                  '_blank'
                )
                Modal.destroyAll()
              }}
            >
              <FaDownload style={{ marginRight: '6px' }} />
              {t('v4:download_sharelook')}
            </Button>
          </div>
        </div>
      ),
      okText: 'Close',
      width: 400,
      centered: true
    })
  }

  // Alternative simple method using Ant Design message
  showSimpleMessage = deepLink => {
    const { t } = this.props
    Modal.confirm({
      title: t('v5:open_sharelook_application'),
      content: t('v5:this_will_launch_sharelook_for_screen_capture'),
      okText: t('v5:open'),
      cancelText: t('v4:cancel'),
      onOk: () => {
        this.attemptAppLaunch(deepLink)
      }
    })
  }

  // Method to check app installation (optional enhancement)
  checkAppInstallation = () => {
    // This is a simple check - can be enhanced based on your needs
    const isWindows = navigator.platform.indexOf('Win') > -1

    if (!isWindows) {
      message.warning('ShareLook is currently only available for Windows.')
      return false
    }

    return true
  }

  // Enhanced handler with installation check
  handleScreenRecordingWithCheck = async () => {
    // Check if running on supported platform
    if (!this.checkAppInstallation()) {
      return
    }

    // Proceed with normal flow
    await this.handleScreenRecording()
  }

  render() {
    const {
      form: { getFieldDecorator, getFieldValue },
      courseBuilder: {
        courseTitle,
        courseOrganiser,
        courseImg,
        lessons,
        courseId,
        coursePassScore,
        courseBadgeId,
        courseCertId,
        courseAttachmentDetails,
        courseEmails,
        courseLang,
        courseCategories,
        templateData
      },
      course: { isFetching, item: course },
      history,
      rootPath,
      user: {
        info: {
          id: userId,
          isAdmin,
          active_organization_id: activeOrgId,
          is_super_admin: isSuperAdmin,
          organization
        }
      },

      organizations: { rows },
      t,
      form,
      orgCategoryList
    } = this.props
    const selectInput = document.getElementById('react-select-2-input')
    if (selectInput) {
      selectInput.maxLength = 50
    }

    const customStyles = {
      control: provided => ({
        ...provided,
        borderRadius: '8px',
        transition: 'transparent 0.3s cubic-bezier(0.215, 0.61, 0.355, 1)',
        marginBottom: isTopicsMax ? '0px' : '24px'
      }),
      menu: provided => ({
        ...provided,
        maxHeight: '185px'
      }),
      menuList: provided => ({
        ...provided,
        maxHeight: '185px'
      })
    }
    const groupOptions = rows ? rows.filter(o => o.id === activeOrgId)[0] : {}

    const {
      isCoverLoading,
      isFinishing,
      isSaving,
      value,
      options,
      isTopicLoading,
      isTopicsMax,
      isMarketPlace,
      isBadgeLoading,
      isCertificateLoading,
      openBadgeModal,
      openCertificateModal,
      showContactModal,
      emailList,
      fetching,
      isCreator,
      isCreatingCourseByHuman,
      showAiCourseCreationModal,
      isFetchingAiContent,
      aiContent,
      openTemplateModal,
      isGeneratingCourse
    } = this.state
    const publishButtonCondition = course.is_restricted
      ? false
      : activeOrgId ||
      isCreator ||
      (course && course.host_ids && course.host_ids.includes(userId)) ||
      isSuperAdmin

    const { DragHandle, Page, Pages } = this
    return (
      <Spin className="global_ant_spin" spinning={isFetching}>
        <section className="section" style={{ paddingBottom: '10rem' }}>
          <FormHeader
            courseId={courseId}
            t={t}
            form={form}
            isAdmin={isAdmin}
            isSuperAdmin={isSuperAdmin}
            isMarketPlace={isMarketPlace}
            onToggleMarketPlace={this.onToggleMarketPlace}
            isRestricted={course.is_restricted}
            isCreatingCourseByHuman={isCreatingCourseByHuman}
            onToggleCreatingCourseByHuman={this.onToggleCreatingCourseByHuman}
            isCourseAiEnabled={organization && organization.enable_ai_course}
            isAiGenerated={course.is_ai_generated}
          />
          {!courseId && <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              type="primary"
              onClick={() => this.context.startTour('create-course', this.state.isCreatingCourseByHuman)}
              className="shl-secondary-btn"
            >
              <Icon type="compass" /> <span>{t('take_a_tour')}</span>
            </Button>
          </div>}


          <Form onSubmit={this.handleSubmit}>
            <div className="create-course">
              <div className="create-course__content">
                <Row gutter={[16, 16]}>
                  <Col
                    md={isMarketPlace ? 3 : 4}
                    xs={24}
                    sm={12}
                    lg={20}
                    xl={21}
                  >
                    <Form.Item
                      label={t('labels:title')}
                      colon={false}
                      required={false}
                      data-tour="course-title"
                    >
                      {getFieldDecorator('title', {
                        initialValue: courseTitle,
                        rules: [
                          {
                            required: true,
                            message: t('errors:title_course')
                          },
                          {
                            whitespace: true,
                            pattern: '.{3,}',
                            message: t('errors:min_3char')
                          }
                        ]
                      })(
                        <Input
                          count={{
                            show: true,
                            max: 10
                          }}
                          size="large"
                          placeholder={t('placeholders:title')}
                          maxLength={100}
                          onChange={e => this.handleTitle(e.target.value)}
                        />
                      )}
                    </Form.Item>
                  </Col>

                  {!isMarketPlace && (
                    <Col xs={24} sm={12} md={3} lg={20} xl={21}>
                      <Form.Item
                        label={t('labels:organiser')}
                        colon={false}
                        required={false}
                        data-tour="course-organiser"
                      >
                        {getFieldDecorator('organiser', {
                          initialValue: courseOrganiser
                        })(
                          <Input
                            addonBefore={t('general:by')}
                            size="large"
                            tighter="true"
                            placeholder={t('placeholders:organiser')}
                            onChange={e => this.handleOrganiser(e.target.value)}
                          />
                        )}
                      </Form.Item>
                    </Col>
                  )}
                  <Col
                    md={isMarketPlace ? 3 : 4}
                    xs={24}
                    sm={12}
                    lg={20}
                    xl={21}
                    data-tour="course-topics"
                  >
                    <div className="marketplace-topic">
                      {t('labels:topics')}
                    </div>
                    <CreatableSelect
                      styles={customStyles}
                      components={{
                        ClearIndicator: null,
                        DropdownIndicator: null,
                        LoadingIndicator: this.LoadingIndicator
                      }}
                      isMulti
                      placeholder={t('v3:add_topic')}
                      inputId="react-select-2-input"
                      isLoading={isTopicLoading}
                      menuIsOpen={this.isModalSelectOpen()}
                      onBlur={() => this.setState({ inputValue: '' })}
                      onChange={this.handleChange}
                      onCreateOption={this.handleCreate}
                      onInputChange={this.loadOptions}
                      options={options}
                      value={value}
                    />

                    {isTopicsMax && (
                      <div className="error_message">
                        {t('errors:topics_max')}
                      </div>
                    )}
                  </Col>
                  {isMarketPlace && (
                    <>
                      <Col md={3} xs={24} sm={12} lg={20} xl={21}>
                        <Form.Item
                          label={t('v4:pass_score')}
                          colon={false}
                          required={false}
                        >
                          {getFieldDecorator('pass_score', {
                            initialValue: coursePassScore,
                            rules: [
                              {
                                type: 'number',
                                asyncValidator: (rule, value) => {
                                  return new Promise((resolve, reject) => {
                                    if (
                                      (value > 0 && value <= 100) ||
                                      value === undefined ||
                                      value === null
                                    ) {
                                      resolve()
                                    } else {
                                      reject(t('v4:pass_score_mark'))
                                    }
                                  })
                                }
                              }
                            ]
                          })(
                            <InputNumber
                              size="large"
                              tighter="true"
                              style={{ width: '100%' }}
                              onChange={value => this.handlePassScore(value)}
                              placeholder={t('v5:minimum_score')}
                            />
                          )}
                        </Form.Item>
                      </Col>
                      <Col md={3}>
                        <Form.Item
                          label={t('v4:allow_others')}
                          colon={false}
                          required={false}
                        >
                          {getFieldDecorator('host_emails', {
                            initialValue: courseEmails
                          })(
                            <Select
                              mode="multiple"
                              placeholder={t('placeholders:email')}
                              filterOption={false}
                              onSearch={this.handleUserSearch}
                              onChange={this.handleEmailChange}
                              style={{ width: '100%' }}
                              size="large"
                              tighter="true"
                            >
                              {this.simplifyUserList(emailList).map(d => (
                                <Option key={d.value}>{d.text}</Option>
                              ))}
                            </Select>
                          )}
                        </Form.Item>
                        <span
                          role="button"
                          style={{
                            position: 'relative',
                            top: '-53px',
                            float: 'right',
                            paddingRight: '10px',
                            cursor: 'pointer',
                            height: 0
                          }}
                          onClick={() =>
                            !fetching ? this.toggleContactModal() : null
                          }
                        >
                          {fetching ? (
                            <Icon type="loading" />
                          ) : (
                            <SearchOutlined />
                          )}
                        </span>
                      </Col>
                    </>
                  )}
                </Row>
                {isMarketPlace && (
                  <MarketPlaceTopSection
                    props={this.props}
                    onChangeAuthor={val => this.handleOrganiser(val)}
                  />
                )}
                <Row gutter={[16, 16]}>
                  <Col md={3} xs={24} sm={12} lg={20} xl={21}>
                    <Form.Item
                      label={t('v4:pass_score')}
                      colon={false}
                      required={false}
                      data-tour="course-pass-score"
                    >
                      {getFieldDecorator('pass_score', {
                        initialValue: coursePassScore,
                        rules: [
                          {
                            type: 'number',
                            asyncValidator: (rule, value) => {
                              return new Promise((resolve, reject) => {
                                if (
                                  (value > 0 && value <= 100) ||
                                  value === undefined ||
                                  value === null
                                ) {
                                  resolve()
                                } else {
                                  reject(t('v4:pass_score_mark'))
                                }
                              })
                            }
                          }
                        ]
                      })(
                        <InputNumber
                          size="large"
                          tighter="true"
                          style={{ width: '100%' }}
                          onChange={value => this.handlePassScore(value)}
                          placeholder={t('v5:minimum_score')}
                        />
                      )}
                    </Form.Item>
                  </Col>
                  <Col md={3} xs={24} sm={12} lg={20} xl={21}>
                    <Form.Item
                      label={t('v4:allow_others')}
                      colon={false}
                      required={false}
                    >
                      {getFieldDecorator('host_emails', {
                        initialValue: courseEmails
                      })(
                        <Select
                          mode="multiple"
                          placeholder={t('placeholders:email')}
                          filterOption={false}
                          onSearch={this.handleUserSearch}
                          onChange={this.handleEmailChange}
                          style={{ width: '100%' }}
                          size="large"
                          tighter="true"
                        >
                          {this.simplifyUserList(emailList).map(d => (
                            <Option key={d.value}>{d.text}</Option>
                          ))}
                        </Select>
                      )}
                    </Form.Item>
                    <span
                      role="button"
                      style={{
                        position: 'relative',
                        top: '-53px',
                        float: 'right',
                        paddingRight: '10px',
                        cursor: 'pointer',
                        height: 0
                      }}
                      onClick={() =>
                        !fetching ? this.toggleContactModal() : null
                      }
                    >
                      {fetching ? <Icon type="loading" /> : <SearchOutlined />}
                    </span>
                  </Col>

                  <Col md={3} xs={24} sm={12} lg={20} xl={21}>
                    <Form.Item
                      label={
                        t('v4:select_course_language') +
                        ' (Optional)'
                      }
                      colon={false}
                    >
                      <Select
                        placeholder={t('v4:select_language')}
                        value={courseLang}
                        showSearch
                        onChange={e => this.handleChangeLang(e)}
                        style={{ width: '100%' }}
                        size="large"
                        tighter="true"
                      >
                        {langOptions.map(item => (
                          <Option key={item.code} value={item.code}>
                            {item.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col md={3} xs={24} sm={12} lg={20} xl={21}>
                    <Form.Item
                      label={t('v3:category')}
                      colon={false}
                      required={false}
                    >
                      {getFieldDecorator('categories', {
                        initialValue: courseCategories
                      })(
                        <Select
                          mode="multiple"
                          placeholder={t('v3:phCategory')}
                          style={{ width: '100%' }}
                          size="large"
                          tighter="true"
                          showSearch={false}
                          onChange={this.handleCategoryChange}
                        >
                          {orgCategoryList.map(item => (
                            <Option
                              key={item.id}
                              value={item.id}
                              label={item.name}
                            >
                              {item.name}
                            </Option>
                          ))}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                </Row>
                <AntRow
                  gutter={[16, 16]}
                  type="flex"
                  style={{ marginBottom: 16 }}
                >
                  <AntCol style={{ flex: '0 1 auto' }} data-tour="course-certificate">
                    <Button
                      className={`item ${courseCertId ? 'icon-check' : ''}`}
                      shape="round"
                      icon={courseCertId ? 'check' : 'plus'}
                      onClick={this.toggleCertificateModal}
                      loading={isCertificateLoading}
                    >
                      {courseCertId
                        ? t('v4:certificate_added')
                        : t('v4:create_certificate')}
                    </Button>
                  </AntCol>
                  <AntCol style={{ flex: '0 1 auto' }} data-tour="course-badge">
                    <Button
                      className={`item ${courseBadgeId ? 'icon-check' : ''}`}
                      icon={courseBadgeId ? 'check' : 'plus'}
                      onClick={this.toggleBadgeModal}
                      shape="round"
                      loading={isBadgeLoading}
                    >
                      {courseBadgeId
                        ? t('v4:badge_added')
                        : t('v4:create_badge')}
                    </Button>
                  </AntCol>
                  {course && course.is_ai_generated && (
                    <AntCol style={{ flex: '0 1 auto' }}>
                      <Button
                        ghost
                        type="primary"
                        icon="setting"
                        onClick={this.toggleTemplateModal}
                        shape="round"
                        loading={isGeneratingCourse}
                      >
                        {t('v4:manage_course_template')}
                      </Button>
                    </AntCol>
                  )}
                </AntRow>

                <Row className="shl-image-file" gutter={[16, 16]}>
                  <Col xs={12} sm={12} md={12} lg={12} xl={6} data-tour="course-cover-image">
                    <ImageSelect
                      form={form}
                      label={t('labels:picture')}
                      coverInput={courseImg}
                      onCoverChange={this.onCoverChange}
                    />
                  </Col>
                  <Col xs={12} sm={12} md={12} lg={12} xl={6}>
                    <FileUpload
                      files={courseAttachmentDetails}
                      onFiles={this.onFiles}
                    />
                  </Col>
                </Row>
                <div className="create-course">
                  <MarketPlaceBottomSection
                    {...this.props}
                    isMarketPlace={false}
                    onDescription={this.handleDescription}
                    onObjectives={this.handleObjectives}
                    onOutline={this.handleOutline}
                    onShareProfile={this.handleShareProfile}
                    onMarketPlaceDescription={this.handleMarketPlaceDescription}
                  />
                </div>
                {isMarketPlace && (
                  <MarketPlaceMidSection
                    {...this.props}
                    courseId={courseId}
                    onCategory={this.handleCategory}
                    onSwitch={this.handleSwitch}
                    onPrice={this.handlePrice}
                    onVideoLink={this.handleVideoLink}
                    onNoOfVideo={this.handleNumberOfVideos}
                    onNoOfLessons={this.handleNumberOfLessons}
                    onTrainerLinkedIn={this.handleTrainerLinkedIn}
                    onTrainerBio={this.handleTrainerBio}
                    onPriceToEdit={this.handlePriceToEdit}
                    onEditPermission={this.handleEditPermission}
                  />
                )}
              </div>
              {!isMarketPlace && isCreatingCourseByHuman && (
                <div className="create-course__sidebar" data-tour="course-lessons">
                  <Lessons>
                    <Lessons.Count left darkBorder>
                      {(lessons.list.length || 0) > 1
                        ? t('general:lessons')
                        : t('general:lesson')}{' '}
                      ({lessons.list.length})
                    </Lessons.Count>

                    <Lessons.List dashed>
                      {!lessons.fetch ? (
                        <>
                          <Pages
                            useDragHandle
                            onSortEnd={this.onSortEnd}
                            helperClass="_drag"
                          >
                            {lessons.list.map((lesson, index) => (
                              <Page key={`item-${index}`} index={index}>
                                <div className="b-page">
                                  <div className="b-page__handler">
                                    <DragHandle />
                                  </div>
                                  <div
                                    className="b-page__info"
                                    onClick={() =>
                                      this.showLessonById(lesson.id)
                                    }
                                  >
                                    <div className="b-page__name">
                                      {!lesson.cover ? (
                                        <Tooltip title="This lesson has no cover image.">
                                          <Lessons.ItemCover cover="">
                                            <Icon
                                              type="question"
                                              style={{ color: 'red' }}
                                            />
                                          </Lessons.ItemCover>
                                        </Tooltip>
                                      ) : (
                                        <Lessons.ItemCover
                                          cover={lesson.cover.link}
                                        />
                                      )}
                                      <Tooltip title={lesson.title}>
                                        <span className="lesson_title">
                                          {lesson.title}
                                        </span>
                                      </Tooltip>
                                    </div>
                                    <div className="b-page__control">
                                      <Popconfirm
                                        title={t('delete_warning')}
                                        okText={t('general:yes')}
                                        cancelText={t('general:no')}
                                        placement="leftTop"
                                        onClick={e => e.stopPropagation()}
                                        onCancel={e => e.stopPropagation()}
                                        onConfirm={e =>
                                          this.deleteLesson(e, lesson.id)
                                        }
                                        icon={false}
                                      >
                                        <Icon type="delete" />
                                      </Popconfirm>
                                    </div>
                                  </div>
                                </div>
                              </Page>
                            ))}
                          </Pages>
                          <div className="add-lession-btn">
                            <div className="button-group">
                              <Button
                                type="primary"
                                icon="plus"
                                className="shl-secondary-btn"
                                onClick={() => {
                                  if (this.context && this.context.endTour) {
                                    this.context.endTour()
                                  }
                                  history.push(`${rootPath}/lesson`)
                                }}
                                disabled={!courseId || isCoverLoading}
                                loading={isCoverLoading}
                              >
                                {t('v3:add_lesson')}
                              </Button>

                              <div className="or-divider">{t('v5:or')}</div>

                              <Button
                                type="primary"
                                icon="plus"
                                className="shl-secondary-btn"
                                onClick={() => {
                                  if (this.context && this.context.endTour) {
                                    this.context.endTour()
                                  }
                                  this.handleScreenRecording(false)
                                }}
                                disabled={!courseId || isCoverLoading}
                                loading={isCoverLoading}
                              >
                                <span>
                                  {t('v3:add_lesson')}
                                  <br />
                                  {t('v5:as_screen_capture')}
                                </span>
                              </Button>
                            </div>
                          </div>
                        </>
                      ) : (
                        <ContentLoader />
                      )}
                    </Lessons.List>
                  </Lessons>
                </div>
              )}
            </div>
            {isMarketPlace && (
              <>
                <div className="create-course">
                  <MarketPlaceBottomSection
                    {...this.props}
                    isMarketPlace={isMarketPlace}
                    onDescription={this.handleDescription}
                    onObjectives={this.handleObjectives}
                    onOutline={this.handleOutline}
                    onShareProfile={this.handleShareProfile}
                    onMarketPlaceDescription={this.handleMarketPlaceDescription}
                  />
                </div>
                <AntRow type="flex" justify="end">
                  <AntCol>
                    <Button
                      size="large"
                      shape="round"
                      onClick={this.onToggleMarketPlace}
                      className="shl-primary-btn"
                    >
                      {t('v3:save_and_continue')}
                    </Button>
                  </AntCol>
                </AntRow>
              </>
            )}
          </Form>
        </section>

        {!isMarketPlace && (
          <div className="p-footer">
            <div className="p-footer__inner" data-tour="course-publish-button">
              <div className="p-footer__item">
                <Tooltip title={t('v4:tooltip_save')} placement={'leftBottom'}>
                  <Button
                    className="rounded"
                    onClick={this.handleSubmit}
                    loading={isSaving}
                  >
                    {t('buttons:save_for_later')}{' '}
                    {courseId && <span>({t('general:autosaved')})</span>}
                  </Button>
                </Tooltip>
              </div>
              <div className="p-footer__item">
                {!isCreatingCourseByHuman ? (
                  <Tooltip
                    title={t('v4:tooltip_next')}
                    placement={'leftBottom'}
                  >
                    <Button
                      onClick={() => this.handleOpenModel()}
                      disabled={!courseId}
                      loading={isFetchingAiContent}
                      type="primary"
                      className="rounded shl-primary-btn"
                    >
                      {t('v4:tooltip_next')}
                      <Icon type="right" />
                    </Button>
                  </Tooltip>
                ) : publishButtonCondition ? (
                  <Tooltip
                    title={t('v4:tooltip_publish')}
                    placement={'leftBottom'}
                  >
                    <Button
                      onClick={() => this.finish(true)}
                      loading={isFinishing}
                      type="primary"
                      className="rounded"
                      disabled={!lessons.list.length}
                    >
                      {t('buttons:publish')}
                      <Icon type="right" />
                    </Button>
                  </Tooltip>
                ) : (
                  <Tooltip
                    title={t('v4:tooltip_finish')}
                    placement={'leftBottom'}
                  >
                    <Button
                      onClick={() => this.finish(false)}
                      loading={isFinishing}
                      type="primary"
                      className="rounded"
                      disabled={!lessons.list.length}
                    >
                      {t('buttons:finish')}
                    </Button>
                  </Tooltip>
                )}
              </div>
            </div>
          </div>
        )}
        <AiTemplateSelection
          type={templateData && templateData.template_id ? 'EDIT' : 'ADD'}
          open={openTemplateModal}
          courseTemplateData={templateData}
          isGeneratingCourse={isGeneratingCourse}
          close={this.toggleTemplateModal}
          onConfirm={this.confirmSetCourseTemplate}
        />
        {showAiCourseCreationModal && (
          <AiCourseCreation
            aiContent={aiContent}
            onCancel={this.handleTableOfContentModalClose}
            courseTitle={courseTitle}
          />
        )}
        {showAiCourseCreationModal && (
          <AiCourseCreation
            aiContent={aiContent}
            onCancel={this.handleTableOfContentModalClose}
            courseTitle={courseTitle}
          />
        )}
        {openBadgeModal && (
          <Modal
            style={{ top: 20 }}
            bodyStyle={{ height: 'auto', maxHeight: '90vh', overflowY: 'auto' }}
            visible={openBadgeModal}
            onCancel={this.toggleBadgeModal}
            footer={null}
            width="1229px"
            afterVisibleChange={visible => {
              if (visible) {
                // Scroll to top when modal becomes visible
                setTimeout(() => {
                  const modalBody = document.querySelector('.ant-modal-body')
                  if (modalBody) {
                    modalBody.scrollTop = 0
                  }

                  const badgeModalWrap = document.querySelector(
                    '.badge-creator-modal-wrap'
                  )
                  if (badgeModalWrap) {
                    badgeModalWrap.scrollTop = 0
                  }
                }, 100)
              }
            }}
          >
            <Badge
              courseBadgeId={courseBadgeId}
              onUploadImage={body =>
                this.badgePresentationUpload(body, 'Badge')
              }
              {...this.props}
            />
          </Modal>
        )}
        {openCertificateModal && (
          <Modal
            style={{ top: 1 }}
            bodyStyle={{ height: 'auto' }}
            visible={openCertificateModal}
            onCancel={this.toggleCertificateModal}
            footer={null}
            width="70%"
            centered
            className="cert-modal-popup"
          >
            <Certificate
              type={'Course'}
              onUploadImage={body =>
                this.badgePresentationUpload(body, 'Certificate')
              }
              {...this.props}
            />
          </Modal>
        )}
        <Modal
          visible={showContactModal}
          onCancel={this.toggleContactModal}
          width={700}
          footer={null}
        >
          <ShowContactsModal
            t={t}
            fetching={fetching}
            orgUsers={emailList}
            groupOptions={groupOptions}
            addEmails={this.handleEmailChange}
            active_organization_id={activeOrgId}
            selectedEmails={getFieldValue('host_emails')}
            tagValue="course"
          />
        </Modal>
      </Spin>
    )
  }
}


// Use TourContext directly in class component
CourseCreateMain.contextType = TourContext

export default Form.create()(withTranslation('coursecreate')(CourseCreateMain))
